import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/bharatpur.jpg";
import Newsletter from "../../shared/Newsletter";
import { Helmet } from 'react-helmet';
const Bharatpur = () => {
  return (
    <>
      <Helmet>
        <title>Bharatpur, Rajasthan | The Rustic Paths</title>

        <meta charset="UTF-8" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta
          name="description"
          content="Explore the picturesque city of Bharatpur in Rajasthan, India with The Rustic Paths. Immerse yourself in the natural beauty of Bharatpur Bird Sanctuary, discover historical landmarks, and experience the cultural richness of this enchanting destination. Plan your journey with our private driver services and witness the charm of Bharatpur's diverse attractions."
        />
        <meta
          name="keywords"
          content="Bharatpur, Rajasthan, private driver, The Rustic Paths, places to visit in bharatpur, places near bharatpur, Bharatpur Bird Sanctuary, historical landmarks, cultural richness, diverse attractions"
        />
        <meta name="author" content="The Rustic Paths" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Bharatpur, Rajasthan - The Rustic Paths"
        />
        <meta
          property="og:description"
          content="Explore the picturesque city of Bharatpur in Rajasthan, India with The Rustic Paths. Immerse yourself in the natural beauty of Bharatpur Bird Sanctuary, discover historical landmarks, and experience the cultural richness of this enchanting destination. Plan your journey with our private driver services and witness the charm of Bharatpur's diverse attractions."
        />
        <meta
          property="og:url"
          content="https://therusticpaths.com/destinations/Rajasthan/bharatpur"
        />
        <meta property="og:image" content={tour1} />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Bharatpur, Rajasthan - The Rustic Paths"
        />
        <meta
          name="twitter:description"
          content="Explore the picturesque city of Bharatpur in Rajasthan, India with The Rustic Paths. Immerse yourself in the natural beauty of Bharatpur Bird Sanctuary, discover historical landmarks, and experience the cultural richness of this enchanting destination. Plan your journey with our private driver services and witness the charm of Bharatpur's diverse attractions."
        />
        <meta name="twitter:image" content={tour1} />

        <link rel="icon" href="./../../assets/images/bharatpur.jpg" type="image/x-icon" />
      </Helmet>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          Bharatpur
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Bharatpur Palace</li>
                      <li>The Lohagarh Fort</li>
                      <li>Keoladeo National Park</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Bharatpur
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    Bharatpur - The 'Eastern Gateway to Rajasthan', was founded
                    by Maharaja Suraj Mal in 1733 AD, it was once an impregnable
                    well fortified city, carved out of the region formerly known
                    as Mewat. The place was named as Bharatpur after the name of
                    Bharat, the brother of Lord Rama, whose other brother Laxman
                    was worshipped as the family deity of the Bharatpur.
                  </p>
                  <p>
                    The legends say the rulers Laxman's name is engraved on the
                    state arms and the seals. The city and the fort have been
                    believed to be founded by Rustam, a Jat of Sogariya clan.
                    Maharaja Suraj Mal took over from Khemkaran, the son of
                    Rustam, and established the empire. He fortified the city by
                    building a massive wall around the city.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bharatpur Palace
                  </h2>

                  <p>
                    It is a fine blend of Mughal and Rajput architecture, built
                    in various phases by different Maharajas. The magnificent
                    apartments are richly decorated with patterned floor tiles
                    with exquisite intricate designs. The museum occupies the
                    main central wing depicting collections dating back to 2nd
                    century, which reflect the art and skill of the region.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    The Lohagarh Fort
                  </h2>
                  <p>
                    The Lohagarh Fort,or the Iron Fort, true to its name stood
                    solidly in front of many British attacks, and frustrated
                    them to ends. It faced the British onslaught four times and
                    after a long siege they had to withdraw, but Lord Lake,
                    however was successful in capturing it in 1804. It is very
                    different from the other forts in state, there is no
                    flamboyance associated to fort but it generates an aura of
                    strength and magnificence. The fort is surrounded with moat
                    which was previously filled with water to ward off the enemy
                    attacks. The sandy ramparts were strengthened by sandy
                    battlements, thus the enemy guns proved of no avail. Some
                    interesting monuments in the fort are Kishori Mahal, Mahal
                    Khas and Kothi Khas. Moti Mahal and towers like Jawahar Burj
                    and Fateh Burj were erected to commemorate the victory over
                    the Mughals and the British army. The Gateway has paintings
                    of huge elephants
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Keoladeo National Park
                  </h2>
                  <p>
                    Keoladeo National Park, is a paradise for bird watchers. The
                    geographical location is ideal as it is on the main
                    North-South avian route of India. It boasts of more than 375
                    species of beautiful birds. The Kingfishers, Pelicans,
                    Siberian cranes, open billed storks, painted storks, egrets,
                    ibises, cormorants, darters or snake birds, spoonbills, grey
                    herons are some of the species observed.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Bharatpur;
